export default __webpack_public_path__ + "static/media/Adi2.6e713f8a.jpg";